export default __webpack_public_path__ + "static/media/selected-plan-icon.46384039.svg";